
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { UserModule } from "@/store/modules/user";
import Voice from "../voice.vue";
import { uploadByPieces } from "./utils";
import { getHeads } from "@/config/constant";

const icons = ["@/assets/user/android.png", "@/assets/user/ios.png"];

@Component({
    components: {
        Voice,
    },
})
export default class extends Vue {
    @Prop({
        default: () => {
            return [];
        },
    })
    private value!: object[];
    @Prop({ default: false }) private showClose!: boolean; // 是否显示关闭按钮
    @Prop({ default: 1 }) private limit!: number; // 允许最大能上传个数
    @Prop({ default: "image" }) private type!: string; // 上传类型（头像、图片、视频、音频）
    @Prop({ default: "1001" }) private code!: string; // 图片类型：(1001：上传头像）(1002：用户截图）(1003：订单图片) (1004：发布动态图片)(3001：个人介绍语音)
    @Prop({ default: "0" }) private parentCode!: string; // 其他组件代码
    @Prop({
        default: () => {
            return { width: "100px", height: "100px" };
        },
    })
    private imageStyle!: any;
    @Prop({ default: false }) private isVideoVal!: boolean; //视频是否把这个对象返回
    @Prop({ default: false }) private block!: boolean; // 是否分块上传
    @Prop({ default: false }) private disabled!: boolean; // 是够禁用
    @Prop({}) private videoMsgElse!: any;
    @Prop({ default: false }) private isOneImgs!: boolean; //单张图片预览

    private filesData: any[] = []; // 文件数据列表
    // private fileList: object[] = []; // 上传文件列表
    private percent: number = 0; //上传进度条
    private isUploading: boolean = false; // 是否正在上传
    private requestParams: object = {}; // 上传携带参数
    private fileType: string = ".png,.jpg,.gif"; // 上传文件类型
    private serveUrl: string = process.env.VUE_APP_BASE_API + "/upload/image"; // 服务器地址
    private videoMsg: any = {};

    get headers() {
        return getHeads();
    }

    get isShow() {
        if (this.limit == 1) {
            if (this.type == "audio" && (this as any).filesData.url) {
                return false;
            }
            return true;
        } else {
            if (this.filesData.length < this.limit && !this.disabled) {
                return true;
            } else {
                return false;
            }
        }
    }

    @Watch("value", { immediate: true })
    changeVal() {
        // console.log('value',this.value);
        if (this.type == "avatar" || this.block) {
            this.filesData = [];
            if (this.value) {
                this.filesData = [{ url: this.value }];
            }
        } else {
            if (this.limit != 1) {
                if (Array.isArray(this.value)) {
                    let arr: any[] = [];

                    for (let item of this.value) {
                        arr.push({ url: item });
                    }

                    this.filesData = arr;
                }
            } else {
                this.filesData = [];
                if (this.value) {
                    // console.log('inthis',this.type,this.value);
                    if (this.type == "audio") {
                        this.filesData = this.value;
                    }else if (this.type == "video") {
                        this.videoMsg = this.value;
                    } else {
                        if(Array.isArray(this.value)){
                            let arr: any[] = [];

                            for (let item of this.value) {
                                arr.push({ url: item });
                            }

                            this.filesData = arr;
                        }else{
                            this.filesData = [{ url: this.value }];
                        }
                    }
                }
            }
        }
    }

    loadErr(e:any){
        console.log('【图片加载失败】',e);

    }

    preImg(){
        console.log('click');
        if(this.limit == 1){
            console.log('预览');
            this.$emit('preview');
        }
    }

    private mounted() {
        if (this.videoMsgElse) {
            this.videoMsg = this.videoMsgElse;
        }

        if (this.type == "audio") {
            this.fileType = "aac,.mp3,.wav,.m4a";
            this.serveUrl = process.env.VUE_APP_BASE_API + "/upload/audio";
        } else if (this.type == "video") {
            this.fileType = ".mp4,FLV,mov";
            this.serveUrl = process.env.VUE_APP_BASE_API + "/upload/video";
        } else if (this.type == "app") {
            this.fileType = ".apk, .ipa";
        }
    }

    /*
     * 分块上传处理
     */
    private beforeBlockUpload(file: any) {
        const isLt1G = file.size / 1024 / 1024 < 1024;
        if (!isLt1G) {
            this.$message.error("改文件大小不能超过 1G!");
        }

        this.percent = 0;
        return isLt1G;
    }

    // 处理分块上传请求
    private handleUploadRequest(back: any) {
        let files = [back.file];
        this.isUploading = true;

        uploadByPieces({
            files,
            pieceSize: 5, // 分片大小 5=5M
            chunkUrl: process.env.VUE_APP_BASE_API + "/upload/chunks",
            // chunkUrl: "/upload/chunks", // 单个文件上传的地址
            fileUrl: "/upload/chunk", // 整个文件上传的地址
            fileKey: (this as any).$md5(
                new Date().getTime() + Math.random() + "chunkBolb"
            ),
            progress: (num: any) => {
                this.percent = num;
            },
            success: (res: any) => {
                let { file } = res.data;

                if (res.code == 1000) {
                    this.percent = 100;
                    this.$message.success({
                        message: res.msg,
                        duration: 2000,
                    });
                    if (this.block && this.type == "app") {
                        if (file.icon) {
                            let url = decodeURI(file.icon);
                            this.$emit("input", url);
                        } else {
                            if (file.ext == "apk") {
                                this.$emit("input", icons[0]);
                            } else if (file.ext == "ios") {
                                this.$emit("input", icons[1]);
                            } else {
                                this.$emit("input", "默认图片");
                            }
                        }

                        this.$emit("handSuccess", file);
                    }
                    this.isUploading = false;
                }
            },
            error: (e: any) => {
                this.isUploading = false;
                this.$message.error("接口请求失败，请刷新后重试");
            },
            warning: (res: any) => {
                this.isUploading = false;
                this.$message.warning(res.msg);
            },
        });
    }

    /*
     *  普通上传
     */
    private exceedDeal(file: any) {
        this.$message.warning({
            message: `一次最多上传${this.limit}张`,
            duration: 2000,
        });
        return;
    }

    // 上传之前钩子函数
    private dealFiles(file: any) {
        this.isUploading = true;

        Object.assign(this.requestParams, {
            type: this.code ? this.code : "",
            parentCode: this.parentCode ? this.parentCode : "0",

        });
    }

    // 上传进度条
    private handleProgress(event: any, file: any, fileList: any) {
        this.percent = parseInt(event.percent);
    }

    // 上传成功钩子函数
    private handleFilesSuccess(res: any, file: any, fileList: any) {
        if (res.code == 1000) {
            this.$message({
                message: res.msg,
                type: "success",
                duration: 2000,
            });

            if (this.type == "avatar") {
                this.$emit("input", res.data.url);
            } else if (this.type == "audio") {
                this.$emit("input", res.data);
            } else {
                if (this.limit == 1) {
                    if (this.type == "video") {
                        this.videoMsg = res.data;
                        if(this.isVideoVal){
                            this.$emit("input", res.data);
                            return
                        }
                    }
                    this.$emit("input", res.data.url);
                } else {
                    this.$emit("input", [...this.value, res.data.url]);
                }
            }
            this.$emit("handSuccess", res.data);
            this.$emit("handSuccessCallback" ,res.data);
        } else {
            this.$message({
                message: res.msg,
                type: "warning",
                duration: 2000,
            });
        }

        this.isUploading = false;
        this.percent = 0;

        if (this.limit == 1) {
            (this as any).$refs.uploadRef.clearFiles();
        }
    }

    // 上传失败的回调函数
    private handleFilesError(err: any, file: any, fileList: any) {
        this.$message({
            message: "上传失败",
            type: "error",
            duration: 2000,
        });

        this.$emit("handleFail", err);
    }

    // 关闭图片
    close(index: any, val: any) {
        this.$emit("close", index, val);
    }

    // 删除音频
    delAudio() {
        this.filesData = [];
        this.$emit("delAudio");
    }

    // 点击关闭按钮（视频）
    closeVideo() {
        this.videoMsg = {};
        this.$emit("delVideo", "");
        this.$emit("input", "");
    }

    // 播放视频
    playVideo() {
        this.$emit("playVideo", this.videoMsg);
    }
}
